import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from 'app/pages/login/login.component';
import { DashboardComponent } from 'app/pages/dashboard/dashboard.component';
import { AuthGuard } from 'app/guards/auth.guard';
import { ROUTES } from './utils/constants/routes.constants';
import { AddBreakComponent } from './pages/dashboard/timesheet/add-break/add-break.component';
import { Page404Component } from './pages/page404/404.component';

const routes: Routes = [
  {
    path: '404',
    component: Page404Component,
  },
  {
    path: '',
    redirectTo: '/404',
    pathMatch: 'full',
  },
  {
    path: ':companyID',
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      {
        path: ROUTES.DASHBOARD,
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.ADD_BREAK,
        component: AddBreakComponent,
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: '/404' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
